<template>
  <div style="width:100%;">
      <img src="../../assets/imags/404.jpg" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style>
img{
    width: 100%;
    height: 933px;
}
</style>